import { moduleProviderFactory } from 'core/providers';
import { ProductTypeEdit, ProductTypeList } from 'application/product-type/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.product-type',
                pattern: '/product-type',
                children: [
                    {
                        name: 'master.app.main.product-type.list',
                        pattern: '',
                        tabTitle: 'PRODUCT_TYPE.LIST.TITLE_SECONDARY',
                        component: ProductTypeList,
                        data: {
                            title: 'PRODUCT_TYPE.LIST.TITLE_SECONDARY'
                        }
                    },
                   {
                        name: 'master.app.main.product-type.create',
                        pattern: '/create',
                        tabTitle: 'Create Product Type',
                        component: ProductTypeEdit,
                        authorization: 'portalSection.create',
                        data: {
                            title: 'PRODUCT_TYPE.CREATE.TITLE'
                        },
                    },
                    {
                        name: 'master.app.main.product-type.edit',
                        pattern: '/edit/:id',
                        tabTitle: 'Edit Product Type',
                        component: ProductTypeEdit,
                        authorization: 'portalSection.update',
                        data: {
                            title: 'PRODUCT_TYPE.EDIT.TITLE'
                        },
                    }                 
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.MASTER_DATA',
                order: 7,
                icon: 'database',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.PRODUCT_TYPE_SUB',
                        route: 'master.app.main.product-type.list',
                        order: 11,
                    }                    
                ]
            }
        ]
    });
})();
